import Vue from "vue";
import Router from "vue-router";
import App from "@/App.vue";
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "home",
      component: App,
    },
    {
      path: "/desktop",
      name: "home",
      component: App,
    },
    {
      path: "/location",
      name: "location",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "location" */ "./views/Location.vue"),
      props: (route) => ({
        ...route.params,
      }),
    },
    {
      path: "/type",
      name: "type",
      component: () => import(/* webpackChunkName: "type" */ "./views/Type.vue"),
      props: (route) => ({
        ...route.params,
      }),
    },
    {
      path: "/position",
      name: "position",
      component: () => import(/* webpackChunkName: "position" */ "./views/Position.vue"),
      props: (route) => ({
        ...route.params,
      }),
    },
    {
      path: "/intervention/:position?/:state?",
      name: "intervention",
      component: () => import(/* webpackChunkName: "position" */ "./views/Position.vue"),
      props: (route) => ({
        ...route.params,
      }),
    },
    {
      path: "/list",
      name: "list",
      component: () => import(/* webpackChunkName: "list" */ "./views/List.vue"),
      props: (route) => ({
        ...route.params,
      }),
    },
    {
      path: "/calculation",
      name: "calculation",
      component: () => import(/* webpackChunkName: "calculation" */ "./views/Calculation.vue"),
      props: (route) => ({
        ...route.params,
      }),
    },
  ],
});
